import { render, staticRenderFns } from "./IconTypeformFileUpload.vue?vue&type=template&id=5c1d3f48&"
import script from "./IconTypeformFileUpload.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformFileUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports